<template>
  <div>
    <div class="order-list-wrap">
      <div class="order-list-header font-s20 clearfix mb-16">
        <div class="fl">
          <div
            class="font-c999 mr-40 fl item"
            :class="currentTabId === 0 && 'activity'"
            @click="resetTab(0)"
          >
            {{ TLang("全部订单", "list") }}
          </div>
          <div
            class="font-c999 mr-40 fl item"
            :class="currentTabId === 1 && 'activity'"
            @click="resetTab(1)"
          >
            {{ TLang("待支付", "list")
            }}<em class="font-red">({{ unpaidAmount }})</em>
          </div>
          <div
            class="font-c999 fl item"
            :class="currentTabId === 5 && 'activity'"
            @click="resetTab(5)"
          >
            {{ TLang("退款相关", "list") }}
          </div>
        </div>
        <div class="fr">
          <a :href="historyLink" class="history_order fl" target="_self">
            <span>{{ TLang("历史订单", "list") }}</span>
          </a>
          <div class="prelative fl">
            <input
              :value="searchOrderNo"
              type="text"
              class="input"
              maxlength="30"
              :placeholder="TLang('请输入订单编号进行查询', 'orderConfirm')"
              style="width: 250px"
              @input="fetchOrderListByOrderNo"
            />
            <img
              :src="require('@assets/images/order/search-icon.png')"
              style="
                display: inline-block;
                vertical-align: middle;
                text-indent: -9999px;
                width: 14px;
                height: 14px;
                position: absolute;
                right: 5px;
                top: 14px;
              "
            />
          </div>
        </div>
      </div>
      <div class="order-list-subheader">
        <div class="order-thead top-order-thead clearfix mb-16">
          <div class="fl font-c666 order-thead-item" style="width: 472px">
            {{ TLang("订单详情", "list") }}
          </div>
          <div class="fl font-c666 order-thead-item">
            {{ TLang("收货人", "address") }}
          </div>
          <div class="fl font-c666 order-thead-item">
            {{ TLang("合计", "orderConfirm") }}（{{ union_name }}）
          </div>
          <div class="fl font-c666 order-thead-item prelative item-hover">
            <span
              >{{ currentOrderStateItem
              }}<img
                :src="require('@assets/images/order/arrow-down.png')"
                class="arrow-icon"
            /></span>
            <ul class="list">
              <li
                v-for="(orderStateItem, index) in orderState"
                :key="index"
                class="item"
                @click="onCheckOrder(orderStateItem)"
              >
                {{ orderStateItem.name }}
              </li>
            </ul>
          </div>
          <div class="fl font-c666 order-thead-item">
            {{ TLang("操作", "list") }}
          </div>
        </div>
        <div v-loading="loading" :style="loading && { height: '795px' }">
          <div
            v-for="orderItem in orderList"
            :key="orderItem.id"
            class="order-tbody"
          >
            <div class="order-thead">
              <span class="font-c999 mr-40"
                >{{ TLang("订单号", "list") }}：{{ orderItem.orderNo }}</span
              >
              <span class="font-c999"
                >{{ TLang("下单时间", "list") }}：{{
                  orderItem.orderDate
                }}</span
              >
              <!-- v-if="orderItem.canDelete" -->
              <div
                v-if="orderItem.delete"
                class="del-order"
                @click="clickDeleteOrder(orderItem.orderNo)"
              >
                <img
                  :src="require('@assets/images/order/order-del.png')"
                  alt=""
                />
              </div>
            </div>
            <div class="order-tbody-item clearfix">
              <div>
                <div
                  v-for="goodsItem in orderItem.goodsList"
                  :key="goodsItem.id"
                  class="goods-item clearfix"
                >
                  <div class="goods-img-wrap fl mr-12">
                    <img :src="goodsItem.goodsImgGuide" alt="" />
                    <!-- 爆炸贴图片 -->
                    <Sticker :imgList="goodsItem.stickerImgList" />
                  </div>
                  <div class="info clearfix fl">
                    <div
                      class="text mb-12 line-clamp-2"
                      :class="goodsItem.giftType != 2 ? 'hover-class' : ''"
                      @click="onNavigatorToProduct(goodsItem)"
                    >
                      <i :style="{ fontStyle: 'normal' }">
                        <SingleTag
                          :show="goodsItem.giftType == 4"
                          :datas="{ name: TLang('奖品', 'list') }"
                          :putName="'PrizeGoods'"
                        />
                      </i>
                      <i
                        v-for="(tag, index) in goodsItem.tags"
                        :key="index"
                        :style="{ fontStyle: 'normal' }"
                      >
                        <SingleTag
                          :show="tag.mktFrontType === 9005"
                          :datas="tag"
                        />
                      </i>
                      {{ goodsItem.giftType == 2 ? goodsItem.specValue : goodsItem.goodsName }}
                    </div>
                    <div class="font-c999 mb-4" v-if="goodsItem.giftType != 2">
                      {{ TLang("规格", "orderConfirm") }}：{{
                        goodsItem.specValue
                      }}
                    </div>
                    <div class="font-c999">
                      {{ TLang("仓库编码", "list") }}：{{
                        goodsItem.merchantCode
                      }}
                    </div>
                  </div>
                  <div class="font-num fr text-right">
                    <span v-if="orderItem.isShowPrice === 1">
                      {{
                        Number(goodsItem.goodsPrice * union_scale).toFixed(2)
                      }}
                    </span>
                    ×{{ goodsItem.quantity }}
                  </div>
                </div>
              </div>
              <div style="vertical-align: top">
                <el-popover
                  placement="top-start"
                  :title="orderItem.recvName + ' ' + orderItem.recvMobile"
                  width="200"
                  trigger="hover"
                  :content="orderItem.recvAddr"
                >
                  <el-button slot="reference">
                    <span
                      style="
                        display: inline-block;
                        max-width: 70px;
                        overflow: hidden;
                        white-space: nowrap;
                      "
                      >{{ orderItem.recvName }}</span
                    >
                    <img
                      :src="require('@assets/images/order/pepole-icon.png')"
                      class="pepole-icon"
                    />
                  </el-button>
                </el-popover>
              </div>
              <div style="vertical-align: top">
                <div
                  v-if="orderItem.isShowPrice === 1"
                  class="font-num-bold font-c111 mb-4"
                >
                  {{
                    !orderItem.totalPayment
                      ? Number(0).toFixed(2)
                      : Number(orderItem.totalPayment * union_scale).toFixed(2)
                  }}
                </div>
                <div v-if="orderItem.isShowPrice === 1" class="font-cccc">
                  ({{ TLang("含运费", "list")
                  }}{{
                    !orderItem.freight
                      ? Number(0).toFixed(2)
                      : Number(orderItem.freight * union_scale).toFixed(2)
                  }})
                </div>
              </div>
              <div class="font-s14" style="vertical-align: top">
                <div class="mb-8" :class="orderItem.style">
                  {{ TLang(orderItem.title, "list") }}
                </div>
                <div
                  v-if="
                    [3, 4, 6].indexOf(orderItem.orderStatus) <= -1 ||
                    ([3, 4, 6].indexOf(orderItem.orderStatus) > -1 &&
                      orderItem.auditStatus !== 'audit')
                  "
                  class="mb-8"
                  :style="'    width: max-content;padding: 0px 4px; margin-left: auto;border-radius: 9px; margin-right: auto;color:' + applyStatus[orderItem.auditStatus]+';background:' + applyStatusBg[orderItem.auditStatus]"
                >
                  {{ orderItem.auditStatusText }}
                </div>
                <div class="hover-class" @click="pushToOrderDetail(orderItem)">
                  {{ TLang("订单详情", "list") }}
                </div>
              </div>
              <div>
                <div v-if="orderItem.orderStatus == 1" class="pb-12">
                  <!-- <img
                    :src="require('@assets/images/order/timer-icon.png')"
                    class="timer-icon"
                  /> -->
                  <span v-if="orderItem.auditStatus === 'audit'">{{
                    TLang("审核剩余", "paypending")
                  }}</span>
                  <span v-else>{{
                    TLang("支付剩余", "paypending")
                  }}&nbsp;</span>

                  <countDown2
                    v-if="orderItem.auditStatus === 'audit'"
                    :payLeftTime="orderItem.auditTimeoutAt"
                  ></countDown2>
                  <CountDown
                    v-else
                    :payLeftTime="orderItem.payLeftTime"
                    @cb="$parent.fetchOrderList()"
                  ></CountDown>
                  <div style="position: relative">
                    <!-- <el-tooltip
                      v-if="orderItem.auditStatus === 'audit'"
                      class="item"
                      effect="dark"
                      :content="TLang('请在订单审核通过后完成支付', 'paypending')"
                      placement="bottom-end"
                    > -->
                    <div
                      v-if="orderItem.auditStatus === 'audit'"
                      :style="
                        'opacity: 0.5'
                      "
                      :class="[
                        'btn-theme-w88',
                        'mb-12',
                        'mt-12',
                        CookiesOne == 'en-US' ? 'continueBtn' : '',
                      ]"
                      @mouseenter="auditStatusShow = true; orderItemIndex = orderItem.orderNo;"
                      @mouseleave="auditStatusShow = false"
                    >
                      {{ TLang("继续支付", "list") }}
                    </div>
                    <!-- </el-tooltip> -->
                    <div
                      v-if="orderItem.auditStatus != 'audit'"
                      :style="
                        'opacity: 1'
                      "
                      :class="[
                        'btn-theme-w88',
                        'mb-12',
                        'mt-12',
                        CookiesOne == 'en-US' ? 'continueBtn' : '',
                      ]"
                      @click="onNavigator(orderItem)"
                    >
                      {{ TLang("继续支付", "list") }}
                    </div>
                    <div
                      v-if="auditStatusShow && orderItemIndex == orderItem.orderNo"
                      class="tips-audit"
                      @click="auditStatusShow = false"
                    >
                      {{ TLang("请在订单审核通过后完成支付", "paypending") }}
                    </div>
                    <div
                      class="btn-default-w88"
                      @click="changeDialogState(orderItem.orderNo)"
                    >
                      {{ TLang("取消订单", "list") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!orderList.length && !loading"
            class="text-center"
            style="padding-top: 80px"
          >
            <img src="@/assets/images/order/order-empty.png" alt="" />
            <div class="font-s16 font-c999" style="padding-bottom: 50px">
              <div>{{ TLang("还没有您的订单哦", "list") }}</div>
              <div>{{ TLang("赶紧去购物吧", "list") }}</div>
            </div>
            <div
              class="btn-theme-w135 m-0-auto"
              @click="
                () => {
                  $router.push('/shopping/cart');
                }
              "
            >
              {{ TLang("去逛逛", "orderConfirm") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirmDialog
      :img="require('@assets/images/order.png')"
      :title="TLang('您要取消订单吗', 'orderConfirm')"
      :desc="TLang('您要取消订单吗', 'orderConfirm')"
      :confirmBtnText="TLang('取消订单', 'list')"
      :cancelBtnText="TLang('暂不取消', 'orderConfirm')"
      @onConfirmDialog="onCancelOrder"
      @onCancelDialog="
        () => {
          confirmDialog = false;
        }
      "
    />
    <el-dialog
      :visible.sync="delModalVisible"
      width="30%"
      :show-close="false"
      :center="true"
      top="50vh"
      custom-class="del-modal"
    >
      <div class="del-modal_wrap">
        <img src="@assets/images/order/order_del.png" alt="" />
        <h2>{{ TLang("删除订单", "my") }}</h2>
        <p>{{ TLang("删除后将无法找回订单", "my") }}</p>
        <div class="bottom-btn-wrap">
          <div class="close-btn" @click="delModalVisible = false">
            {{ TLang("再想想", "my") }}
          </div>
          <div class="confirm-btn" @click="confirmDelOrder">
            {{ TLang("删除订单", "my") }}
          </div>
        </div>
      </div>
      <div class="close-icon" @click="delModalVisible = false">
        <img src="@assets/images/order/order_close.png" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import confirmDialog from "@components/confirmDialog";
import Sticker from "@components/sticker";
import SingleTag from "@components/singleTag";
import { mapActions, mapState } from "vuex";
import Cookies from "js-cookie";
import CountDown from "./countDown";
import countDown2 from "./countDown2";
import { deleteOrder, getPayUrl } from "@fetch/order";
import { unionFlag } from "@utils";
import API_ENV from "@utils/API_ENV";
import Toast from "@components/simpleToast";
export default {
  name: "OrderList",
  components: {
    confirmDialog,
    CountDown,
    countDown2,
    Sticker,
    SingleTag,
  },
  props: {
    orderList: Array,
    unpaidAmount: Number,
    loading: Boolean,
    historyLink: String,
  },
  data() {
    return {
      confirmDialog: false,
      currentOrderStateItem: this.TLang("全部订单", "list"),
      currentTabId: 0,
      searchOrderNo: null,
      delModalVisible: false,
      orderState: [
        {
          id: 0,
          name: this.TLang("全部订单", "list"),
        },
        {
          id: 1,
          name: this.TLang("待支付", "list"),
        },
        {
          id: 2,
          name: this.TLang("已支付", "list"),
        },
        {
          id: 3,
          name: this.TLang("已完成", "list"),
        },
        {
          id: 4,
          name: this.TLang("已取消", "list"),
        },
        // 退款相关目前只显示在 header 里
        // {
        //   id: 5,
        //   name: '退款相关',
        // }
      ],
      // 审批状态
      applyStatus: {
        audit: "#FF6600",
        pass: "#00B87A",
        rejected: "#F44545",
        timeout: "#F44545",
      },
      applyStatusBg: {
        audit: "#FFF7F2",
        pass: "#F2FBF8",
        rejected: "#FEF5F5",
        timeout: "#FEF5F5",
      },
      CookiesOne: Cookies.get("df_lang"),
      orderItemIndex: 0,
      auditStatusShow: false,
    };
  },
  methods: {
    ...mapActions("orderList", ["cancelOrder"]),
    fetchOrderListByOrderNo(e) {
      const value = e.target.value || null;
      this.$parent.searchOrderNo = value;
      this.searchOrderNo = value;
      this.$parent.tab = 0;
      this.currentTabId = 0;
      this.$parent.currPage = 1;
      this.$parent.initData();
    },
    clickDeleteOrder(orderNo) {
      if (orderNo) {
        this.activeOrderNo = orderNo;
        this.delModalVisible = true;
      }
    },
    confirmDelOrder() {
      deleteOrder({ orderNo: this.activeOrderNo }).then((res) => {
        this.$parent.initData();
      });
      this.activeOrderNo = "";
      this.delModalVisible = false;
    },
    changeDialogState(orderNo) {
      this.confirmDialog = !this.confirmDialog;
      this.orderNo = orderNo;
    },
    onNavigator(orderInfo) {
      if (orderInfo.auditStatus === "audit") {
        Toast.info(this.TLang("请在订单审核通过后完成支付", "paypending"), 1);
        return;
      }
      const params = {
        orderNo: orderInfo.orderNo,
        terminalType: "PC",
      };
      getPayUrl(params).then((res) => {
        if (res && res.url) {
          window.location.href = res.url;
        } else {
          setTimeout(() => {
            this.$parent.initData();
          }, 1000);
        }
      });
    },
    onNavigatorToProduct(item) {
      if (item.giftType != 2) {
        const { categoryId, goodsId } = item;
        if (item.channel && item.channel === 7) {
          let origin = "";
          if (API_ENV === "test05" || API_ENV === "development") {
            // 生产环境
            origin = "//exchange-test05.dongfangfuli.com";
          } else if (API_ENV === "uat" || API_ENV === "stage") {
            // 生产环境
            origin = "//exchange-stage.dongfangfuli.com";
          } else {
            origin = "//exchange.dongfangfuli.com";
          }
          window.location.href = `${origin}/bfd_gift_pc/productDetail?goodsId=${item.goodsId}&categoryId=${item.categoryId}`;
        } else {
          this.$router.push(`/product/detail?cid=${categoryId}&gid=${goodsId}`);
        }
      }
    },
    onCancelOrder() {
      const { orderNo } = this;
      this.cancelOrder({
        orderNo,
        deliveryOrderCancelRemark: this.TLang("取消订单", "list"),
        cancelAll: true,
        success: () => {
          this.confirmDialog = false;
          this.$parent.initData();
          this.$message.success(this.TLang("订单已取消", "orderConfirm"));
        },
        error: () => (this.confirmDialog = false),
      });
    },
    onCheckOrder(item) {
      this.currentOrderStateItem = item.name;
      this.resetTab(item.id);
    },
    resetTab(id) {
      this.$parent.tab = id;
      this.currentTabId = id;
      this.$parent.currPage = 1;
      this.$parent.searchOrderNo = null;
      this.searchOrderNo = null;
      this.$parent.initData();
    },
    pushToOrderDetail(item) {
      // 跳转至订单详情
      this.$router.push("/order/detail/" + item.orderNo);
    },
  },
};
</script>

<style lang="less" scoped>
.order-list-wrap {
  width: 992px;
  box-sizing: border-box;

  .history_order {
    width: auto;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    margin-right: 16px;
    text-align: center;
    background: rgba(247, 247, 247, 1)
      url("~@assets/images/order/history_icon.png") no-repeat 10px center;
    text-indent: 14px;
    border-radius: 2px;
    font-size: 12px;
  
    color: rgba(17, 17, 17, 1);

    &:hover {
      background-color: #ecf5fd;
      color: #268ee7;
      background: rgba(247, 247, 247, 1)
        url("~@assets/images/order/history_hover_icon.png") no-repeat 10px
        center;
    }
  }
  .order-list-header {
    .item {
      cursor: pointer;
    }
    .activity {
      position: relative;
      color: #333 !important;

      &:after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
      }
    }
  }
  .arrow-icon {
    width: 12px;
    height: 12px;
    vertical-align: text-top;
    margin-left: 3px;
    -webkit-transition: -webkit-transform 0.3s;
    transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
    transition: transform 0.3s, -webkit-transform 0.3s;
  }
  .order-thead {
    padding: 0;
    padding-left: 16px;
    display: flex;
    .item-hover {
      cursor: pointer;
      &:hover {
        .arrow-icon {
          transform: rotate(180deg);
        }
        .list {
          position: absolute;
          top: 50px;
          left: 15px;
          z-index: 2001;
          transform-origin: center top;
          display: block;
        }
      }
    }
    .del-order {
      margin-left: auto;
      margin-right: 16px;
      img {
        width: 20px;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  .order-thead.top-order-thead {
    background-color: #f0f0f0;
  }
  .order-tbody {
    border: solid 1px #e5e5e5;
    margin-top: 24px;

    &:first-of-type {
      margin-top: 0;
    }

    .order-tbody-item {
      width: 100%;
      display: table;
      height: 112px;
      box-sizing: border-box;
      &:last-of-type {
        height: 130px;
      }

      .pepole-icon {
        width: 14px;
        height: 14px;
        vertical-align: text-top;
        margin-left: 3px;
      }

      .timer-icon {
        width: 12px;
        height: 12px;
        vertical-align: middle;
        margin-right: 2px;
      }

      .goods-item {
        padding: 18px 16px 0 16px;
        box-sizing: border-box;

        &:first-of-type {
          padding-top: 0;
        }

        img {
          width: 90px;
          height: 90px;
        }

        .info {
          width: 200px;

          div {
            width: 100%;
          }
        }
      }
    }
  }

  .order-thead-item,
  .order-tbody-item > div {
    text-align: center;
    width: 116px;
    display: table-cell;

    &:first-of-type {
      width: 488px;
      text-align: left;
    }
    &:last-of-type {
      width: 155px;
      div {
        margin: 0 auto;
      }
    }
  }

  .order-tbody-item > div {
    text-align: center;
    height: 100%;
    padding-top: 18px;
    border-left: solid 1px #e5e5e5;
    box-sizing: border-box;

    .hover-class {
      &:hover {
        color: #3d96e2;
        cursor: pointer;
      }
    }

    &:nth-of-type(1) {
      border: none;
      padding-bottom: 18px !important;
    }
  }
}
.tips-audit {
  width: 201px;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  right: 33px;
  margin-top: 8px;
  max-height: 41px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 19px;
  padding: 10px 8px;
  border-radius: 4px;
}
.tips-audit::before {
  content: "";
  position: absolute;
  width: 0px;
  height: 0px;
  top: -14px;
  right: 45px;
  border-top: 7px solid transparent;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.8);
}
</style>
<style lang="less">
.del-modal {
  transform: translateY(-60%);
  padding-bottom: 22px;
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .del-modal_wrap {
    text-align: center;
    .bottom-btn-wrap {
      display: flex;
      font-size: 14px;
    
      text-align: center;
      line-height: 40px;
      justify-content: center;
      margin-top: 28px;
      margin-bottom: 22px;
      .close-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        font-weight: bold;
      }
      .confirm-btn {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(229, 229, 229, 1);
        margin-left: 30px;
      }
    }
    img {
      width: 62px;
      height: 56px;
      margin-top: 14px;
    }
    h2 {
      font-size: 18px;
    
      color: rgba(51, 51, 51, 1);
      line-height: 44px;
    }
    p {
      font-size: 14px;
    
      color: rgba(102, 102, 102, 1);
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.goods-img-wrap {
  position: relative;
}
.continueBtn {
  //width: auto !important;
  //max-width: 110px;
}
</style>
